import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-eye',
  templateUrl: './eye.component.html',
  styleUrls: ['./eye.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EyeIconComponent {}
